import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { OneWayInService } from 'src/api/v2';
import { ONE_WAY_IN_OPPORTUNITY_RECOMMENDATIONS } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';

const useOpportunityReferrals = (formId?: string) => {
  const [oneWayInService] = useState(new OneWayInService());
  const { checkAccess } = useAuth();
  const { read } = checkAccess('OneWayIn');

  const opportunityReferralsQuery = useQuery({
    queryKey: [ONE_WAY_IN_OPPORTUNITY_RECOMMENDATIONS, formId],
    queryFn: () => oneWayInService.getOpportunityReferrals(formId!),
    enabled: !!formId && read,
    retry: false,
    staleTime: 1000 * 60 * 15, // 15 min refetching on mount
    refetchOnMount: true,
  });

  return { opportunityReferralsQuery };
};

export default useOpportunityReferrals;
